import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import { connect } from 'react-redux';
import withModal from '../../../../lib/hoc/withModal';
import OrderItemStatusChangeModal from '../../../../views/order/common/modal/OrderItemStatusChangeModal';
import { orderActions } from '../../../../store/modules/order';
import { ORDER_ITEM_STATUS } from '../../../../constants/service/app/orderConstants';

class OrderItemStatusChangeModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //--> 변경할 orderItemStatus
      changedStatus: null,
      //--> memo
      memo: null,
    };
  }

  /**
   *  주문 상태 되돌리기
   */
  onSubmit = (prevStatus) => {
    const { form, data, changeOrderItemStatus, changeOrderConfirmsStatus } = this.props;
    const { changedStatus, memo } = this.state;
    const { orderItemId } = data;

    let mainStatus;
    let subStatus;
    if ([ORDER_ITEM_STATUS.CANCELLATION, ORDER_ITEM_STATUS.RETURN, ORDER_ITEM_STATUS.EXCHANGE].includes(prevStatus)) {
      // 취/반/교 - 거부 상태일때
      mainStatus = prevStatus;
      subStatus = changedStatus;
    } else {
      mainStatus = changedStatus;
    }

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      if (prevStatus === ORDER_ITEM_STATUS.PURCHASE_CONFIRMATION) {
        changeOrderConfirmsStatus({
          orderItemId: orderItemId + '',
          memo,
        });
      } else {
        changeOrderItemStatus({
          orderItemId,
          changedStatus: mainStatus,
          changedSubStatus: subStatus,
          memo,
        });
      }

      /**
       *  모달 닫기
       */
      this.closeModal();
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'orderItemStatusChangeModal', value: false });
  };

  render() {
    return (
      <OrderItemStatusChangeModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.orderItemStatusChangeModal.isOpen,
    data: state.order.orderItemStatusChangeModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  changeOrderItemStatus: orderActions.changeOrderItemStatus,
  changeOrderConfirmsStatus: orderActions.changeOrderConfirmsStatus,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(OrderItemStatusChangeModalContainer)));
